module.exports = __webpack_public_path__ + "static/shan-d81b5296ef3e4aaa3707d9bf8cd2cb9f.jpeg";